import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-white">
      <div className="text-center">
        {/* Spinner with company colors */}
        <div className="relative w-24 h-24 mx-auto mb-6">
          {/* Outer ring - Blue */}
          <div className="absolute inset-0 border-4 border-[#0693E3] border-t-transparent rounded-full animate-spin"></div>
          {/* Inner ring - Red */}
          <div className="absolute inset-3 border-4 border-[#CF2E2E] border-t-transparent rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '0.8s' }}></div>
          {/* Center logo */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-12 h-12 bg-[#ffffff] rounded-lg flex items-center justify-center">
               <img 
                src="/img/logo.png"
                alt="PT. Gurita Mandala Persada Logo" 
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
        
        {/* Loading text */}
        <div className="space-y-2">
          <p className="text-gray-900 font-semibold text-lg">Loading...</p>
          <div className="flex justify-center space-x-1">
            <div className="w-2 h-2 bg-[#0693E3] rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-[#0693E3] rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-[#0693E3] rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;